import type {
  DocumentEmailPlaceholderKey,
  EmailTemplateDocumentType,
} from '../../utils/documentEmailTemplates';
import {
  DOCUMENT_EMAIL_PLACEHOLDER_NAMES,
  getDefaultDocumentEmailBodyTemplate,
  getDefaultDocumentEmailSubjectTemplate,
} from '../../utils/documentEmailTemplates';

export type DocumentEmailTemplateUiConfig = {
  title: string;
  description: string;
  mailDispatchPurposeLabel: string;
  placeholders: DocumentEmailPlaceholderKey[];
  defaultSubjectTemplate: string;
  defaultBodyTemplate: string;
};

export type DocumentEmailPlaceholderInfo = {
  /** Beschriftung des Einfuege-Buttons. */
  label: string;
  /** Bedeutung samt Beispiel — als Tooltip. */
  hint: string;
  /**
   * Nur im E-Mail-Text ersetzbar. Der Betreff kennt keine Anrede, dort bliebe
   * der Platzhalter woertlich stehen.
   */
  bodyOnly?: boolean;
};

export const DOCUMENT_EMAIL_PLACEHOLDER_INFO: Record<
  DocumentEmailPlaceholderKey,
  DocumentEmailPlaceholderInfo
> = {
  greeting: {
    label: 'Anrede',
    hint: 'Anrede des Unterzeichners, z. B. „Guten Tag Herr Müller,“ — nur im E-Mail-Text',
    bodyOnly: true,
  },
  signerName: { label: 'Unterzeichner', hint: 'Name des Unterzeichners, z. B. „Herr Müller“' },
  documentReference: { label: 'Belegnummer', hint: 'Belegnummer des Dokuments, z. B. „AB-2026-0042“' },
  dateLabel: { label: 'Datum', hint: 'Datum des Dokuments, z. B. „07.08.2026“' },
  customerName: { label: 'Kunde', hint: 'Name des Kunden, z. B. „Muster GmbH“' },
};

/** Name ohne Klammern, z. B. `Belegnummer` — daraus wird im Editor der Chip. */
export function documentEmailPlaceholderName(key: DocumentEmailPlaceholderKey): string {
  return DOCUMENT_EMAIL_PLACEHOLDER_NAMES[key];
}

export const DOCUMENT_EMAIL_TEMPLATE_UI: Record<EmailTemplateDocumentType, DocumentEmailTemplateUiConfig> = {
  Arbeitsbericht: {
    title: 'Arbeitsbericht an Unterzeichner',
    description:
      'E-Mail-Vorlage, wenn aus der Field-App eine Kopie des unterzeichneten Arbeitsberichts an den Unterzeichnenden gesendet wird.',
    mailDispatchPurposeLabel: 'Arbeitsberichte',
    placeholders: ['greeting', 'signerName', 'documentReference', 'dateLabel', 'customerName'],
    defaultSubjectTemplate: getDefaultDocumentEmailSubjectTemplate('Arbeitsbericht'),
    defaultBodyTemplate: getDefaultDocumentEmailBodyTemplate('Arbeitsbericht'),
  },
};
